import moment from "moment";
import { Notification } from "element-ui";
import {ENotificationType} from "@/models/enums";

export function resolve(path: string, obj: any, separator= ".") {
  const properties: string[] = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev: any, curr: any) => prev && prev[curr], obj);
}

export function dateFormatter(row: any, column: any) {
  const propertyValue = resolve(column.property, row);
  return propertyValue === null || propertyValue === undefined ||
    new Date(propertyValue).getTime() <= 0
      ? ""
      : moment(propertyValue).local().format("L LT");
}

export const COLORS = [
  { icon: "mm_20_red", colorClass: "color-red", color: "#f00" },
  { icon: "mm_20_green", colorClass: "color-green", color: "#00e74c" },
  { icon: "mm_20_yellow", colorClass: "color-yellow", color: "#fef569" },
  { icon: "mm_20_blue", colorClass: "color-blue", color: "#6991fc" },
  { icon: "mm_20_purple", colorClass: "color-pink", color: "#e551e4" },
  { icon: "mm_20_orange", colorClass: "color-orange", color: "#ff9900" },
  { icon: "mm_20_brown", colorClass: "color-purple", color: "##cca165" },
  { icon: "mm_20_black", colorClass: "color-ltblue", color: "#000" },
  { icon: "mm_20_white", colorClass: "color-ltblue", color: "#fff" },
  { icon: "mm_20_gray", colorClass: "color-ltblue", color: "#c0c0c0" },
];

export function getIconColor(idx: number) {
  return {
    url: "/tag.png"
  };
}

export function getLoraIcon() {
  return {
    url: "/lpwan.png"
  };
}

export function pushNotification(title: string, message: string, type: ENotificationType) {
  Notification({title, message, type});
}

export function getWifiIcon() {
  return {
    url: "/wifi.png"
  };
}

export function getCircleColor(idx: number) {
  return COLORS[idx].color;
}
